import React from "react";

import { Impulse } from "~/tools/impulse";
import { isTruthy } from "~/tools/is-truthy";
import type { JSON } from "~/tools/json";
import { toJSON } from "~/tools/to-json";
import { usePermanent } from "~/tools/use-permanent";

import { ToggleListRootContextProvider } from "./_toggle-list-root-context";

export interface ToggleListRootProps {
	namespace?: JSON;
}

export const ToggleListRoot: React.FC<React.PropsWithChildren<ToggleListRootProps>> = ({ namespace, children }) => {
	const uniqId = React.useId();
	const rootNamespace = namespace == null ? uniqId : toJSON(namespace);
	const listNamespace = usePermanent(() => Impulse(""));

	const compositeNamespace = React.useMemo(
		() =>
			Impulse<string>(
				(scope) => [rootNamespace, listNamespace.getValue(scope)].filter(isTruthy).join("|"),
				listNamespace,
			),
		[rootNamespace, listNamespace],
	);

	return <ToggleListRootContextProvider value={compositeNamespace}>{children}</ToggleListRootContextProvider>;
};
